<script lang="ts">
  import { currentBrowser } from '../platform/browser';

  // PLAN.md §2/§16: a gentle, dismissible notice on Safari; never blocks.
  const KEY = 'soundlab.safariNoticeDismissed';
  const b = currentBrowser();
  const isWebKit = b.isDesktopSafari || b.isAppleMobile;

  let dismissed = $state(readDismissed());

  function readDismissed(): boolean {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  }

  function dismiss() {
    dismissed = true;
    try {
      localStorage.setItem(KEY, '1');
    } catch {
      /* ignore */
    }
  }
</script>

{#if isWebKit && !dismissed}
  <div class="notice" role="status" data-testid="browser-notice">
    <span>
      {#if b.isAppleMobile}
        SoundLab works on iPad and iPhone. For the smoothest experience with long files, a laptop
        with Chrome or Firefox is recommended.
      {:else}
        SoundLab works in Safari, but Chrome or Firefox are recommended for this course.
      {/if}
    </span>
    <button onclick={dismiss} aria-label="Dismiss browser notice">OK</button>
  </div>
{/if}

<style>
  .notice {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 1rem;
    background: var(--notice-bg);
    border-bottom: 1px solid var(--border);
    font-size: 0.9rem;
  }
</style>
